import React, { useState, useCallback } from "react";

//Returns the caller component content width and height 
//e.g <View onLayout={setViewLayoutSize}> content </View>
//To set state: const [viewLayoutSize, setViewLayoutSize] = useComponentSize();
//To get values: viewLayoutSize.height, viewLayoutSize.width
export const useComponentSize = () => {
    const [size, setSize] = useState(null);
  
    const onLayout = useCallback(event => {
      const { width, height } = event.nativeEvent.layout;
      setSize({ width, height });
    }, []);
  
    return [size, onLayout];
  };